export enum Country {
	CZECHIA = 'czechia',
	SLOVAKIA = 'slovakia',
	PERU = 'peru',
	ECUADOR = 'ecuador',
	MEXICO = 'mexico',
	COLOMBIA = 'colombia',
	DEFAULT = 'default',
}
